'use strict';

(function ($) {
	$("document").ready(function () {
		$('.select-checkbox-js').on('change', function(){
			$(this.dataset.select+' option[value="'+this.value+'"]').attr('selected', this.checked);
		});
		$('.dropdown-keep-open').on('click', function(e){
			e.stopPropagation();
		});
	});
})(jQuery);
